import {
  get,
  post
} from '../axios'

class Checkin {
  async getSignCheckRecords(param) {
    const res = await get('/SignCheck/GetSignCheckRecords', param)
    return res
  }
  async addSignCheckrecords(data,param) {
    const res = await post('/SignCheck/AddSignCheckRecord',data,param)
    return res
  }
  async getSignCheckRecordsByUserAndDate(param) {
    const res = await get('/SignCheck/GetSignCheckRecordsByUserAndDate', param)
    return res
  }
}
export default new Checkin()